"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Success = function Success() {
  return _react2.default.createElement(
    "g",
    { id: "success" },
    _react2.default.createElement("path", {
      d: "M329.254518,170.055221 L212.716939,286.601764 L170.07315,243.957975 C162.22031,236.096171 149.481856,236.096171 141.629016,243.957975 C133.767212,251.810814 133.767212,264.549268 141.629016,272.402108 L198.499354,329.272447 C202.425774,333.198866 207.580321,335.171041 212.725904,335.171041 C217.871486,335.171041 223.017068,333.207831 226.943488,329.272447 L357.707616,198.508319 C365.560456,190.646515 365.560456,177.917025 357.707616,170.055221 C349.845812,162.202381 337.116322,162.202381 329.254518,170.055221 L329.254518,170.055221 Z M249.668316,0 C112.001577,0 0,112.001577 0,249.668316 C0,387.335054 112.001577,499.336633 249.668316,499.336633 C387.335054,499.336633 499.336633,387.335054 499.336633,249.668316 C499.327668,112.001577 387.335054,0 249.668316,0 L249.668316,0 Z M249.668316,459.09531 C134.18854,459.09531 40.2413224,365.148092 40.2413224,249.659351 C40.2413224,134.179575 134.18854,40.232358 249.668316,40.232358 C365.148092,40.232358 459.09531,134.18854 459.09531,249.668316 C459.09531,365.148092 365.148092,459.09531 249.668316,459.09531 L249.668316,459.09531 Z",
      id: "Combined-Shape"
    })
  );
};

exports.default = Success;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Success.js
// module id = 2992
// module chunks = 4